import { useEffect, useRef } from 'react';
import maplibregl from 'maplibre-gl';

interface Use3DControlOptions {
  map: maplibregl.Map | null;
  is3D: boolean;
  onToggle: () => void;
}

export const use3DControl = ({ map, is3D, onToggle }: Use3DControlOptions) => {
  const controlRef = useRef<any>(null);

  useEffect(() => {
    if (!map) return;

    // Create custom 3D toggle control
    class View3DControl {
      container!: HTMLDivElement;
      button!: HTMLButtonElement;

      onAdd(_map: maplibregl.Map) {
        this.container = document.createElement('div');
        this.container.className = 'maplibregl-ctrl maplibregl-ctrl-group';

        this.button = document.createElement('button');
        this.button.className = 'maplibregl-ctrl-icon';
        this.button.type = 'button';
        this.button.title = is3D ? 'Switch to 2D view' : 'Switch to 3D view';
        this.button.innerHTML = is3D ? '2D' : '3D';
        this.button.style.fontWeight = 'bold';
        this.button.style.fontSize = '14px';

        this.button.addEventListener('click', () => {
          onToggle();
        });

        this.container.appendChild(this.button);
        return this.container;
      }

      onRemove() {
        this.container.parentNode?.removeChild(this.container);
      }
    }

    // Remove existing control if it exists
    if (controlRef.current) {
      map.removeControl(controlRef.current);
    }

    // Add new control
    const control = new View3DControl();
    controlRef.current = control;
    map.addControl(control as any, 'top-right');

    return () => {
      if (map && controlRef.current) {
        try {
          map.removeControl(controlRef.current);
        } catch (e) {
          // Map might be destroyed
        }
      }
    };
  }, [map, is3D, onToggle]);
};